import React from 'react';
import { connect } from 'react-redux';
import { isNull, has } from 'lodash/fp';
import { withStatusModifier } from '../helpers.js';
import Link from '../../_shared/Link.js';

const Divider = () => <span className="PathContentStatus-divider">|</span>;

const OverdueBadge = () => (
  <div className="Pill Pill--danger ml-8">
    {t('paths.dashboard.status.overdue')}
  </div>
);

const DueDate = ({ dueDate }) => (
  <span className="PathContentStatus-dueDate">
    {t('paths.dashboard.status.due_on', { date: dueDate })}
  </span>
);

const ConditionalLink = ({ href, children }) => (
  <Link
    if={href}
    href={href}
    children={children}
    linkProps={{ className: 'td-u' }}
  />
);

const hasScore = progress => has('score', progress) && !isNull(progress.score);

const Status = ({
  progress,
  status,
  formattedStatus,
  dueDate,
  isOverdue,
  required,
  dateAdded,
  urls = {},
  previewing,
}) => {
  const StatusContainer = props => (
    <div className={withStatusModifier('PathContentStatus', status)}>
      {props.children}
      {isOverdue && <OverdueBadge />}
    </div>
  );

  const FormattedStatus = () => (
    <StatusContainer>{formattedStatus}</StatusContainer>
  );

  const LinkToReportCard = props => (
    <ConditionalLink href={urls.reportCard} {...props} />
  );

  const statusProps = {
    completed: () => (
      <StatusContainer>
        <LinkToReportCard>
          {t('paths.dashboard.status.completed_on', {
            date: progress.completedDate,
          })}
        </LinkToReportCard>
        {hasScore(progress) && <Divider />}
        {hasScore(progress) && (
          <LinkToReportCard>{progress.score}%</LinkToReportCard>
        )}
      </StatusContainer>
    ),
    inProgress: () => (
      <StatusContainer>
        {t('paths.dashboard.status.started_on', { date: progress.startedDate })}
        {dueDate && <Divider />}
        {dueDate && <DueDate dueDate={dueDate} />}
        {!required && !previewing && <Divider />}
        {!required && !previewing && t('paths.dashboard.status.optional')}
      </StatusContainer>
    ),
    available: () => (
      <StatusContainer>
        {t('paths.dashboard.status.added_on', { date: dateAdded })}
        {!required && !previewing && <Divider />}
        {!required && !previewing && t('paths.dashboard.status.optional')}
        {dueDate && <Divider />}
        {dueDate && <DueDate dueDate={dueDate} />}
      </StatusContainer>
    ),
    locked: () => <FormattedStatus />,
    awaitingGrade: () => <FormattedStatus />,
  };

  return statusProps[status] ? statusProps[status].call() : false;
};

const mapStateToProps = state => ({
  previewing: state.pathViewer.previewing,
});

export default connect(mapStateToProps)(Status);
